import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

import './Press.css'

const PressHero = () => {
  useEffect(() => {
    window.scrollTo(0, 0);   // scroll to top
    AOS.init({ duration: 1000 });
}, []);
  const achievements = [
    {
      icon: "fas fa-share-alt",
      title: "Share Button Patent",
      text: "Pioneered the technology that enabled seamless content sharing across mobile platforms",
    },
    {
      icon: "fas fa-map-marker-alt",
      title: "Geolocation Opt-in/Opt-out",
      text: "Developed location-based permission systems for Android and iPhone platforms",
    },
    {
      icon: "fas fa-sms",
      title: "Text-in Info System",
      text: "Created innovative SMS-based information delivery systems",
    },
    {
      icon: "fas fa-video",
      title: "Media Transmission",
      text: "Enabled photo and video transmission for analog phone systems",
    },
  ];

  const sports = [
    { icon: "fas fa-trophy", text: "Royal Marine & Royal Navy Judo Champion" },
    { icon: "fas fa-shield-alt", text: "Krav Maga & Gutter Fighting Instructor" },
    { icon: "fas fa-medal", text: "Wrestling Gold Medalist (Freestyle, Greco, Sambo)" },
  ];

  const facts = [
    { icon: "fas fa-star", text: "Selected for Marquis Who's Who 2025" },
    { icon: "fas fa-lightbulb", text: "Holder of 5+ Patents in Mobile Technology" },
    { icon: "fas fa-medal", text: "Royal Marine Commando Green Beret Recipient" },
    { icon: "fas fa-trophy", text: "Denver Business Journal Technology Award 2008" },
    { icon: "fas fa-robot", text: "Pioneer in AI-Powered Patent Technology" },
  ];

  const pressResources = [
    { icon: "fas fa-file-pdf", text: "Download Press Release (PDF)" },
    { icon: "fas fa-images", text: "High-Resolution Images" },
    { icon: "fas fa-biohazard", text: "Company Biography" },
    { icon: "fas fa-newspaper", text: "Media Coverage Archive" },
  ];
  return (
    <>
      <Header />
      <section className="press-hero section-container">
        <div className="hero-press-background"></div>

        {/* {[1,2,3,4].map((_,i)=>(
          <div key={i} className="floating-element"></div>
        ))} */}
        <div class="floating-element"></div>
        <div class="floating-element"></div>
        <div class="floating-element"></div>
        <div class="floating-element"></div>
        <div className="content-container">
          <div className="hero-content">

            <div className="press-badge">
              <i className="fas fa-award"></i>
              Marquis Who's Who Selection
            </div>

            <h1 className="hero-title" data-aos="fade-up" data-aos-delay="100">
              Marquis Who's Who Honors Kenneth P. O'Hanlon
            </h1>

            <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
              Outstanding Achievements and Creativity in Technology and Business
            </p>

            <div className="hero-meta" data-aos="fade-up" data-aos-delay="300">
              <span className="meta-item">
                <i className="far fa-calendar"></i>
                October 29, 2025
              </span>

              <span className="meta-item">
                <i className="fas fa-map-marker-alt"></i>
                Parker, CO
              </span>
            </div>

          </div>
        </div>
      </section>
      <section className="press-content-section section-container">
        <div className="content-container">
          <div className="press-wrapper">

            {/* MAIN CONTENT */}
            <main className="press-main">

              <article className="press-article">

                <div className="article-header" >
                  <div className="press-logo">
                    <img
                      src="https://www.marquiswhoswho.com/images/marquis-logo.svg"
                      alt="Marquis Who's Who"
                      className="marquis-logo"
                    />
                  </div>

                  <div className="press-summary">
                    <p>
                      Kenneth P. O'Hanlon is a visionary leader, dynamic thinker,
                      and rainmaker in mobile marketing technology with a
                      track record of motivating teams and a foundation of service
                      in the Royal Marine Commandos.
                    </p>
                  </div>
                </div>

                {/* ARTICLE BODY */}
                <div className="articles-body">

                  <p>
                  PARKER, CO, October 29, 2025 – Kenneth O'Hanlon has been selected for inclusion in Marquis Who's Who. As in all Marquis Who's Who biographical volumes, individual profiles are selected based on current reference value. Factors such as position, noteworthy accomplishments, visibility, and prominence in a field are all considered during the selection process.
                  </p>

                  <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.5rem)" }}>A Distinguished Career of Innovation</h2>
              <p>Mr. O'Hanlon, born in London, has established a distinguished career marked by innovation, resilience, and service. As founder and chief executive officer of Technologist, he has led the company, focusing on developing advanced solutions in the technology sector since 2003. Under his leadership, Mr. O'Hanlon holds several patents that have revolutionized mobile marketing technology.</p>
                  {/* ACHIEVEMENTS */}
                  <div className="achievements-grid" >
                    {achievements.map((item, i) => (
                      <div key={i} className="achievement-card">
                        <div className="achievement-icon">
                          <i className={item.icon}></i>
                        </div>
                        <h4>{item.title}</h4>
                        <p>{item.text}</p>
                      </div>
                    ))}
                  </div>

                  <blockquote className="press-quote">
                    "These achievements underscore his inventive approach and commitment
                    to technological advancement in the mobile marketing space."
                  </blockquote>
                  <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.5rem)" }}>From Royal Marines to Technology Pioneer</h2>
                  <p >Before his current role, Mr. O'Hanlon owned and operated HK Home Inspections in the United States. Drawing on his military background and attention to detail, he established a reputable business offering clients comprehensive property assessments. His transition into entrepreneurship was influenced by his earlier experiences in personal security for high-profile individuals, which required discretion and adaptability.</p>
                  <p>Mr. O'Hanlon's professional journey began with a career in the Royal Marine Commandos of the British Armed Forces. His tenure was defined by perseverance and exceptional accomplishment. Most notably, he completed a grueling 30-mile march over the challenging and rugged terrain across Dartmoor in eight hours—a feat achieved by only six out of an original group of 52 candidates, which earned him the prestigious Green Beret (known by Bootneck's as the Green lid). This milestone stands as a testament to his determination and physical endurance.</p>

                  {/* MILITARY HIGHLIGHT */}
                  <div className="highlight-card military-highlight">
                    <div className="highlight-icon">
                      <i className="fas fa-medal"></i>
                    </div>

                    <div className="highlight-content">
                      <h3>Royal Marine Commandos Achievement</h3>

                      <p>
                        Completed the demanding 30-mile Dartmoor march in 8 hours,
                        earning the Green Beret alongside only 5 other candidates
                        from an original group of 52.
                      </p>
                    </div>
                  </div>
                  <h2 style={{ fontSize: "clamp(1.8rem, 4vw, 2.5rem)" }}>Professional Affiliations and Community Service</h2>
                  <p>Throughout his career, Mr. O'Hanlon has been an active member of several esteemed organizations, including the Freemasons 32nd Degree, the Knights of the Temple, and the Shriners. These affiliations reflect his dedication to personal growth and community service.</p>

                  <p>Beyond his professional pursuits, Mr. O'Hanlon has made significant contributions to civic life. He was pivotal in establishing high school youth rugby in Colorado and supporting women's and men's rugby teams. Additionally, he coached LGBTQ rugby teams, fostering inclusivity within the sport.</p>

                  {/* SPORTS */}
                  <div className="athletic-achievements">

                    <h3>Athletic Accomplishments</h3>

                    <div className="sports-grid">
                      {sports.map((item, i) => (
                        <div key={i} className="sport-item">
                          <i className={item.icon}></i>
                          <span>{item.text}</span>
                        </div>
                      ))}
                    </div>

                  </div>
                  <h2 style={{fontSize: "clamp(1.8rem, 4vw, 2.5rem)"}}>Overcoming Challenges and Building Legacy</h2>
                  <p>Despite facing challenges related to dyslexia during his formative years, when understanding the condition was limited, Mr. O'Hanlon demonstrated remarkable resilience. With support from a patent attorney who recognized his potential, he overcame these obstacles to secure his first and four more patents, exemplifying creativity and perseverance.</p>

                  <p>Family remains central to Mr. O'Hanlon's life; he is the father of seven children and takes great pride in his growing legacy, particularly cherishing the arrival of his great-grandson. He continues supporting his grandson in the United Kingdom as he embarks on a new business venture, offering financial assistance and guidance in website development.</p>

                  <div className="future-vision">
                    <h3>Future Vision</h3>
                    <p>Looking ahead, Mr. O'Hanlon is dedicated to ensuring his developing platform achieves its full potential with AI systems & GAI systems. He remains committed to helping others whenever possible, balancing progress and perfection in all endeavors.</p>
                  </div>

                  {/* VIDEO */}
                  <div className="video-section">

                    <h3>Ask Jeeves AI in Action</h3>

                    <div className="video-placeholder">

                      <div className="video-icon">
                        <i className="fas fa-play-circle"></i>
                      </div>

                      <div className="video-info">

                        <h4>Video Demonstration</h4>

                        <p>
                          Watch our AI-powered patent technology platform in action
                        </p>

                        <a href="#" className="video-btn">
                          <i className="fas fa-play"></i>
                          Play Video
                        </a>

                      </div>

                    </div>

                    <p className="video-caption">
                      Voice Clone Technology Demonstration
                    </p>

                  </div>
                  <div className="about-marquis" >
                    <h3>About Marquis Who's Who®</h3>
                    <p>Since 1899, when A. N. Marquis printed the First Edition of Who's Who in America®, Marquis Who's Who® has chronicled the lives of the most accomplished individuals and innovators from every significant field of endeavor, including politics, business, medicine, law, education, art, religion and entertainment. Who's Who in America® remains an essential biographical source for thousands of researchers, journalists, librarians and executive search firms around the world. The suite of Marquis® publications can be viewed at the official Marquis Who's Who® website, www.marquiswhoswho.com.</p>
                    <p className="disclaimer">Marquis Who's Who ("the company") reserves the right to edit, revise, condense or reject any approved material for style, professionalism and matters of falsity, bigotry, politics, slander, taste, ethics, business practices, or other matters, which the company, at its discretion, may deem offensive, divisive or objectionable.</p>
                  </div>
                  <div className="press-contact">
                    <h3>For Press Inquiries</h3>
                    <div className="contact-info">
                      <p><strong>Media Contact:</strong> Kenneth P. O'Hanlon</p>
                      <p><strong>Company:</strong> Ask Jeeves IP / Technologist</p>
                      <p><strong>Email:</strong> press@askjeevesip.com</p>
                      <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                    </div>
                  </div>
                </div>

              </article>

            </main>

            {/* SIDEBAR */}
            <aside className="press-sidebar">

              {/* PROFILE */}
              <div className="profile-card">

                <div className="profile-image">
                  <img
                    src="https://incubator.ucf.edu/wp-content/uploads/2023/07/artificial-intelligence-new-technology-science-futuristic-abstract-human-brain-ai-technology-cpu-central-processor-unit-chipset-big-data-machine-learning-cyber-mind-domination-generative-ai-scaled-1.jpg"
                    alt="Kenneth P. O'Hanlon"
                  />
                </div>

                <div className="profile-content">

                  <h3>Kenneth P. O'Hanlon</h3>

                  <p className="profile-title">Founder & CEO</p>

                  <div className="profile-details">

                    <div className="detail-item">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>Parker, Colorado</span>
                    </div>

                    <div className="detail-item">
                      <i className="fas fa-birthday-cake"></i>
                      <span>Born in London, UK</span>
                    </div>

                    <div className="detail-item">
                      <i className="fas fa-users"></i>
                      <span>Father of 7 Children</span>
                    </div>

                  </div>

                </div>

              </div>

              {/* FACTS */}
              <div className="facts-widget">

                <h3>Key Facts</h3>

                <ul className="facts-list">

                  {facts.map((item, i) => (
                    <li key={i}>
                      <i className={item.icon}></i>
                      <span>{item.text}</span>
                    </li>
                  ))}

                </ul>

              </div>

              {/* COMPANY */}
              <div className="company-widget">

                <h3>About Ask Jeeves IP</h3>

                <p>
                  Revolutionizing patent protection through AI-powered efficiency
                  and expert legal strategy.
                </p>

                <a href="/about" className="company-btn">
                  <i className="fas fa-info-circle"></i>
                  Learn More About Us
                </a>

              </div>

              {/* PRESS KIT */}
              <div className="press-kit-widget">

                <h3>Press Resources</h3>

                <div className="kit-items">

                  {pressResources.map((item, i) => (
                    <a key={i} href="#" className="kit-item">
                      <i className={item.icon}></i>
                      <span>{item.text}</span>
                    </a>
                  ))}

                </div>

              </div>

            </aside>

          </div>
        </div>
      </section>
      <section className="related-press-section section-container">
        <div className="content-container">
          <div className="section-header">
            <h2>Related Press Coverage</h2>
            <p>Additional recognition and media coverage of our achievements</p>
          </div>

          <div className="press-grid">
            <article className="press-item">
              <div className="press-item-header">
                <span className="press-source">Denver Business Journal</span>
                <span className="press-date">June 6, 2008</span>
              </div>
              <h3 className="press-item-title">Technology Innovation Award</h3>
              <p className="press-item-excerpt">Recognized for groundbreaking mobile marketing technology development and implementation.</p>
              <a href="#" className="press-item-link">Read Article →</a>
            </article>

            <article className="press-item">
              <div className="press-item-header">
                <span className="press-source">TechCrunch</span>
                <span className="press-date">March 15, 2024</span>
              </div>
              <h3 className="press-item-title">AI Revolutionizes Patent Industry</h3>
              <p className="press-item-excerpt">How Ask Jeeves IP is using artificial intelligence to democratize patent protection.</p>
              <a href="#" className="press-item-link">Read Article →</a>
            </article>

            <article className="press-item">
              <div className="press-item-header">
                <span className="press-source">Forbes</span>
                <span className="press-date">January 22, 2024</span>
              </div>
              <h3 className="press-item-title">From Royal Marine to Tech CEO</h3>
              <p className="press-item-excerpt">The unique journey of Kenneth O'Hanlon and his impact on mobile marketing technology.</p>
              <a href="#" className="press-item-link">Read Article →</a>
            </article>
          </div>
        </div>
      </section>
      {/* CTA Section  */}
      <section className="press-cta section-container">
        <div className="content-container">
          <div className="cta-content">
            <h2 className="cta-title">Interested in Our Technology?</h2>
            <p className="cta-text">Learn how our patented AI technology can revolutionize your patent protection and mobile marketing strategies.</p>
            <div className="ctap-buttons">
              <Link to={"/contact"} className="ctap-btn-primary">Schedule a Demo</Link>
              <Link to={"/patents"} className="ctap-btn-secondary">Explore Our Patents</Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PressHero;